import { create } from 'zustand';

interface UIState {
    loading: boolean;
    setLoading: (loading: boolean) => void;
    yesterdayFallsCalendarCheck: boolean;
    setYesterdayFallsCalendarCheck: (check: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
    loading: false,
    setLoading: (loading) => set({ loading }),
    yesterdayFallsCalendarCheck: false,
    setYesterdayFallsCalendarCheck: (check) => set({ yesterdayFallsCalendarCheck: check }),
}));
